import { render } from "./ClassProfile.vue?vue&type=template&id=1321610e&scoped=true"
import script from "./ClassProfile.vue?vue&type=script&lang=js"
export * from "./ClassProfile.vue?vue&type=script&lang=js"

import "./ClassProfile.vue?vue&type=style&index=0&id=1321610e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1321610e"]])

export default __exports__